import styled from 'styled-components';
// exports
export { default as TextareaField } from './TextareaField';
const Textarea = styled.textarea `
  display: block;
  resize: none;
  width: 100%;
  background: ${({ theme }) => theme.colors.grey00_7};
  border-radius: 8px;
  font-family: CircularXXWeb;
  color: ${({ theme }) => theme.colors.black_1};
  &:not(:first-child) {
    margin-top: 4px;
  }
  ${({ theme }) => theme.typography.textMedium}
  border: ${({ theme, error, warning }) => {
    if (error)
        return `1px solid ${theme.colors.critical100}`;
    if (warning)
        return `1px solid ${theme.colors.warning100}`;
    return `1px solid ${theme.colors.grey30_1}`;
}};
  padding: 8px 12px;
  &[disabled],
  &[readonly] {
    background: ${({ theme }) => theme.colors.grey05_3};
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.colors.grey30_2};
  }
  &::placeholder {
    font-family: CircularXXWeb;
    color: ${({ theme }) => theme.colors.grey70_1};
    ${({ theme }) => theme.typography.textMedium}
  }
  &[disabled] {
    color: ${({ theme }) => theme.colors.grey100_2};
    &::placeholder {
      color: ${({ theme }) => theme.colors.grey100_2};
    }
  }
  &:focus {
    ${({ theme, error, warning }) => !error && !warning && `border: 1px solid ${theme.colors.main}`};
    ${({ theme, error, warning }) => {
    if (error)
        return theme.shadows.error;
    if (warning)
        return theme.shadows.warning;
    return theme.shadows.focus;
}};
    outline: none;
  }
  &:not([disabled]):not([readonly]):not(:focus):hover {
    ${({ theme, error, warning }) => !error && !warning && `border: 1px solid ${theme.colors.grey70_1}`};
  }
  padding-bottom: 18px; /* for counter */
`;
export default Textarea;
